import plusLogo from 'assets/images/plus-logo-white.svg';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ColouredText from '../../../components/common/ColouredText';
import Header from '../../../components/layout/Header';
import { accountDetailsRequest } from '../../../modules/account/actions';
import { isAuthenticatedAsOmni, mustLoadSettings } from '../../../modules/account/selectors';
import { getPageName } from '../../../modules/app/selectors';
import hidePeriod from '../../../utils/hidePeriod';
import HeaderMenuButton from '../../common/HeaderMenuButton';
import BalanceConnect from './Balance';

export class DefaultHeader extends Component {
  componentWillMount() {
    const { mustLoadAccountSettings, loadAccountSettings } = this.props;
    if (mustLoadAccountSettings) {
      loadAccountSettings();
    }
  }

  render() {
    const {
      isOmniLinked,
      pageName
    } = this.props;
    let centerComponent;

    if (Array.isArray(pageName)) {
      centerComponent = <ColouredText words={pageName} />;
    } else if (pageName) {
      centerComponent = pageName;
    } else {
      centerComponent = <img className="header__logo" src={plusLogo} role="presentation" />;
    }

    return (
      <Header
        left={() => (
          <HeaderMenuButton />
        )}
        center={() => centerComponent}
        right={() => isOmniLinked && !hidePeriod() && (
          <div className="header__balance">
            <BalanceConnect />
          </div>
        )}
      />
    );
  }
}

DefaultHeader.propTypes = {
  mustLoadAccountSettings: PropTypes.bool,
  loadAccountSettings: PropTypes.func.isRequired,
  isOmniLinked: PropTypes.bool.isRequired,
  pageName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
};

const mapStateToProps = (state) => ({
  mustLoadAccountSettings: mustLoadSettings(state),
  isOmniLinked: isAuthenticatedAsOmni(state),
  pageName: getPageName(state)
});

const mapDispatchToProps = {
  loadAccountSettings: accountDetailsRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
